module.exports = __webpack_public_path__ + "img/8_b.37e5a809.jpg";